import { styled } from '@mui/material';
import { CoreBox } from '@youscience/core';
import CoreDatePicker from '@components/CoreDatePicker';
import { brightpathTheme } from '@youscience/theme';

export const StyledCard = styled('div')(() => ({
  padding: '.25rem 1rem',
  background: brightpathTheme.palette.common.white,
  borderRadius: '.5rem',
}));

export const StyledHeading = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  gap: '1rem',
  alignItems: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
}));

export const StyledDatePicker = styled(CoreDatePicker)(() => ({
  width: '100%',

  '& label.MuiFormLabel-root': {
    top: '-5px',
  },
}));

export const StyledFieldWrapper = styled(CoreBox)(() => ({
  display: 'flex',
  gap: '.5rem',
  flexDirection: 'column',
}));

export const StyledFieldsContainer = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
}));
